module.exports = __webpack_public_path__ + "img/10.7930b2d0.jpg";